import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { strings } from "@/data/strings";
import { languageFromPath, pathForLanguage } from "@/utils/localizedRoutes";

const LangContext = createContext(null);

function initialLang() {
  if (typeof window === "undefined") return "en";
  return languageFromPath(window.location.pathname);
}

export function LangProvider({ children, forcedLang }) {
  const [lang, setLang] = useState(forcedLang || initialLang);

  useEffect(() => {
    if (typeof document === "undefined") return;
    document.documentElement.lang = lang;
  }, [lang]);

  const switchLanguage = useCallback(
    (nextLang) => {
      if (nextLang !== "en" && nextLang !== "es") return;
      if (typeof window === "undefined" || nextLang === lang) return;

      const current = `${window.location.pathname}${window.location.search}${window.location.hash}`;
      window.location.assign(pathForLanguage(current, nextLang));
    },
    [lang]
  );

  const localizePath = useCallback((target) => pathForLanguage(target, lang), [lang]);

  const t = useCallback(
    (key) => {
      const value = key.split(".").reduce((acc, k) => (acc == null ? acc : acc[k]), strings[lang]);
      return value == null ? key : value;
    },
    [lang]
  );
  return (
    <LangContext.Provider value={{ lang, setLang: switchLanguage, localizePath, t }}>
      {children}
    </LangContext.Provider>
  );
}

export const useLang = () => useContext(LangContext);
